module.exports = __webpack_public_path__ + "static/Kaizen_MetaisBasicosAN_Production-0957ca688973242a753744989b04a3c4.jpg";